<h5
    class="mb-2 appTooltip"
    appTooltip="{{consts.TOOLTIP_MESSAGE}}"
    tooltipPosition="right"
>
    {{consts.TITLE}}
    <mat-icon svgIcon="hub_info"></mat-icon>
</h5>

<div class="arrow-wrapper dxc-purple">
    <button
        mat-icon-button
        class="button-arrow"
        (click)="pre()"
        [disabled]="fs < linksPerPage"
    >
        <mat-icon svgIcon="hub_chevron_left"></mat-icon>
    </button>
    <button
        mat-icon-button
        class="button-arrow"
        (click)="next()"
        [disabled]="fs >= linksPerPage"
    >
        <mat-icon svgIcon="hub_chevron_right"></mat-icon>
    </button>
</div>
<div class="recent-documents">
    <mat-spinner matSuffix [diameter]="30" *ngIf="insightsArr.length <= 0"></mat-spinner>
    <label
        class="recent-shared"
        *ngFor="let rs of insightsArr | slice:fs:ls; let i = index"
    >
        <div class="title">
            <a
                href="{{rs.webshorturl}}"
                target="_blank"
                appInsightsTrack
                [eventData]=rs
                loc="{{consts.TITLE}}"
            >
                <mat-icon svgIcon="hub_{{rs.icon}}"></mat-icon>
                <div *ngIf="rs.type === consts.LABEL_INSIGHTS" class="desc-edited">
                    <span>{{consts.LABEL_YOU}}</span>{{consts.LABEL_EDITED}}
                    <div>{{rs.lastAccessed}}</div>
                </div>
                <div *ngIf="rs.type === consts.LABEL_SHARED" class="desc-shared">
                    <span title="{{rs.title}}">{{rs.title}}</span>
                    <span>{{consts.LABEL_SHARED}}</span>
                    <div class="last-accessed">{{rs.lastAccessed}}</div>
                </div>
            </a>
        </div>
        <div class="file-icon">
            <a
                class="recent-detail"
                href="{{rs.webshorturl}}"
                target="_blank"
                appInsightsTrack
                [eventData]=rs
                loc="{{consts.TITLE}}"
            >
                <div class="hasfile" *ngIf="rs.hasfile">
                    <img
                        *ngIf="rs.displayurl"
                        class="img-fluid preview-img"
                        src="{{rs.displayurl}}"
                    >
                    <mat-icon
                        class="icon"
                        *ngIf="!rs.displayurl"
                        svgIcon="hub_{{rs.preimgurl}}"
                    >
                    </mat-icon>
                </div>
                <div class="not-hasfile" *ngIf="!rs.hasfile">
                    <mat-icon
                        class="icon"
                        svgIcon="hub_generic"
                    >
                    </mat-icon>
                    <div 
                        class="extension" 
                        title="{{rs.preimgurl}}"
                    >
                        {{rs.preimgurl}}
                    </div>
                </div>
            </a>
        </div>
        <div class="link-content">
            <h6 title="{{rs.name}}">{{rs.name}}</h6>
            <a
                href="{{rs.webshorturl}}"
                target="_blank"
                rel="noopener noreferrer"
                appInsightsTrack
                [eventData]=rs
                loc="{{consts.TITLE}}"
            >
                {{rs.webshorturl}}
            </a>
        </div>
        <div class="link-menu">
            <div [matMenuTriggerFor]="menu">
                <mat-icon svgIcon="hub_more_horiz"></mat-icon>
            </div>
            <mat-menu #menu="matMenu">
                <button
                    mat-menu-item
                    class="mat-menu-option"
                    (click)="openLink(rs.webshorturl)"
                    appInsightsTrack
                    [eventData]=rs
                    loc="{{consts.TITLE}}"
                    action="Open link"
                >
                    <mat-icon
                        class="menu-icon"
                        svgIcon="hub_folder_icon"
                    >
                    </mat-icon>
                    <span>{{consts.ACTION_OPEN}}</span>
                </button>
                <!-- TODO: Uncomment when sharing and favorite features are available for recommended documents -->
                <!-- <button
                    mat-menu-item
                    disabled
                    class="mat-menu-option"
                    appInsightsTrack
                    [eventData]=rs
                    loc="{{consts.TITLE}}"
                    action="Share link"
                >
                    <mat-icon
                        class="menu-icon"
                        svgIcon="hub_ios_share"
                    >
                    </mat-icon>
                    <span>{{consts.ACTION_SHARE}}</span>
                </button>
                <button
                    mat-menu-item
                    disabled
                    class="mat-menu-option"
                    appInsightsTrack
                    [eventData]=rs
                    loc="{{consts.TITLE}}"
                    action="Set as favorite"
                >
                    <mat-icon
                        class="menu-icon"
                        svgIcon="hub_star_filled"
                    >
                    </mat-icon>
                    <span>{{consts.ACTION_FAVORITE}}</span>
                </button> -->
                <button
                    mat-menu-item
                    class="mat-menu-option"
                    ngxClipboard
                    [cbContent]="rs.webshorturl"
                    (click)="openSnackBar()"
                    appInsightsTrack
                    [eventData]=rs
                    loc="{{consts.TITLE}}"
                    action="{{consts.ACTION_COPY_LINK}}"
                >
                    <mat-icon
                        class="menu-icon"
                        svgIcon="hub_link"
                    >
                    </mat-icon>
                    <span>{{consts.ACTION_COPY_LINK}}</span>
                </button>
            </mat-menu>
        </div>
    </label>
</div>
